import React, { useContext, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import PropTypes from 'prop-types';
import { ModalContext } from 'App';
import * as actions from '../actions';
import * as c from '../constant';

function AddRemarksModal({
  createRichTextEditor,
  addBusinessRemarks,
  formData,
  updateList,
  setFormData,
  id,
  updating,
  getItem,
  draftToHtml,
  htmlToDraft,
  convertToRaw,
}) {
  const setModal = useContext(ModalContext);

  const handleOnSubmit = (e) => {
    e.preventDefault();

    const args = {
      remarks: draftToHtml(convertToRaw(formData.remarks.getCurrentContent())),
    };

    addBusinessRemarks(id, args, () => {
      setModal({ isOpen: false });
      getItem(id);
    });
  };

  const closeModal = (e) => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  const onSetFormData = () => {
    if (!_.isEmpty(updateList)) {
      const args = {
        ...updateList,
        remarks: htmlToDraft(updateList.remarks),
      };

      setFormData(_.pick(args, _.keys(c.FORM_DATA_REMARKS)));
    }
  };

  useEffect(() => {
    onSetFormData();
  }, []);

  return (
    <Modal.Body>
      <form onSubmit={handleOnSubmit}>
        <div className="row">
          <div className="col-12 form-group">
            <span className="transaction-text p-0">
              {createRichTextEditor(
                { key: 'remarks', label: 'Remarks:' },
                {
                  minLength: 3,
                  required: true,
                  maxLength: 500,
                  toolbarHidden: true,
                },
                { wrapperClassName: 'border div-css' }
              )}
            </span>
          </div>
        </div>
        <div className="d-flex justify-content-center top-button">
          <button
            disabled={updating}
            type="submit"
            className="mt-3 btn btn-primary cms-bg-color-primary cms-outline-primary mr-3"
          >
            <span className="font-weight-bold">
              {updating ? <i className="fa fa-spin fa-spinner" /> : `Submit`}
            </span>
          </button>
          <button
            disabled={updating}
            type="button"
            onClick={closeModal}
            className="mt-3 btn btn-dark "
          >
            <span className="font-weight-bold">Cancel</span>
          </button>
        </div>
      </form>
    </Modal.Body>
  );
}

AddRemarksModal.propTypes = {
  updateList: PropTypes.instanceOf(Object).isRequired,
  setFormData: PropTypes.instanceOf(Function).isRequired,
  formData: PropTypes.instanceOf(Object).isRequired,
  addBusinessRemarks: PropTypes.instanceOf(Function).isRequired,
  getItem: PropTypes.instanceOf(Function).isRequired,
  id: PropTypes.string.isRequired,
  updating: PropTypes.bool.isRequired,
  createRichTextEditor: PropTypes.instanceOf(Function).isRequired,
  htmlToDraft: PropTypes.instanceOf(Function).isRequired,
  draftToHtml: PropTypes.instanceOf(Function).isRequired,
  convertToRaw: PropTypes.instanceOf(Function).isRequired,
};

const mapStateToProps = ({ api }) => ({
  updating: api.loading.indexOf(c.ADD_BUSINESS_REMARKS) > -1,
});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(AddRemarksModal);
